/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { UpdatePersonTagsViewModel } from "../types/UpdatePersonTagsViewModel.ts";

export const updatePersonTagsViewModelSchema = z.object({
  tagIds: z
    .array(z.number().int())
    .describe(
      "Lista de IDs das tags a serem associadas à pessoa. Substitui integralmente as tags existentes.",
    )
    .nullish(),
}) as unknown as ToZod<UpdatePersonTagsViewModel>;
